import React, {Fragment} from "react";
import KustomerSetupModalForm from "./KustomerSetupModalForm";
import BasicModal from "../../../../common/BasicModal";
import {basicModalStyle} from "../../Utilities/basicModalStyles";

export default function KustomerSetupModal({
	open,
	handleClose,
	handleOpen
}){
  return(
    <Fragment>
          <BasicModal
            open={open}
            handleClose={handleClose}
            handleOpen={handleOpen}
            title={'Connect with Kustomer'}
            style={basicModalStyle}
          >
            <KustomerSetupModalForm
                description={'Please copy and paste your Kustomer credentials here:'}
                buttonLabel={'Submit'}
                openInNewTab={true}
                extraInfoLabel={'View setup instructions'}
                handleClose={handleClose}
            />
          </BasicModal>
    </Fragment>
  )
}